import EyeOfHorus from './EyeOfHorus'

export default EyeOfHorus
// eslint-disable-next-line import/export
export * from './EyeOfHorus'
